import { Building2 } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFeatureSurface } from '../../FeatureSurfaceContext';
import { TemplateStatusPill } from '../../automations-tab/templates-manager/template-status-pill/TemplateStatusPill';
import { SubscribedTenantsDialog } from '../../automations-tab/templates-manager/templates-table/SubscribedTenantsDialog';
import styles from './segments-manager.module.css';
import type { SegmentListRow } from './types';

const formatDate = (dateString: string | null): string => {
  if (!dateString) {
    return 'N/A';
  }
  try {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return 'N/A';
  }
};

export function SegmentTableRow({
  segment,
  displayName,
  description,
  status,
  syncedTenantCount,
  syncedBusinessIds,
  updatedAt,
}: SegmentListRow) {
  const navigate = useNavigate();
  const featureSurface = useFeatureSurface();
  const [showTenants, setShowTenants] = useState(false);

  const hasSyncedTenants = syncedTenantCount > 0;

  const handleEdit = () => {
    navigate(featureSurface.buildSegmentEditPath(segment.canonicalVersionId));
  };

  return (
    <tr className={styles.row} onClick={handleEdit}>
      <td className={styles.nameCell}>
        <span className={styles.name}>{displayName}</span>
        {description && <span className={styles.description}>{description}</span>}
      </td>
      <td>
        {hasSyncedTenants ? (
          <button
            type="button"
            className={styles.tenantsButton}
            onClick={event => {
              event.stopPropagation();
              setShowTenants(true);
            }}>
            <Building2 className={styles.tenantsIcon} />
            {syncedTenantCount}
          </button>
        ) : (
          <span className={styles.tenantsZero}>0</span>
        )}
        {showTenants && (
          <SubscribedTenantsDialog
            title="Synced tenants"
            templateName={displayName}
            activeBusinessIds={syncedBusinessIds}
            onClose={() => setShowTenants(false)}
          />
        )}
      </td>
      <td>
        <TemplateStatusPill status={status} />
      </td>
      <td className={styles.lastModified}>{formatDate(updatedAt)}</td>
      <td onClick={event => event.stopPropagation()}>
        <button type="button" className={styles.editButton} onClick={handleEdit}>
          Edit
        </button>
      </td>
    </tr>
  );
}
